import { Modal, View } from "react-native";
import { OrganizationList } from "@clerk/clerk-react";

interface RequiredOrganizationModalProps {
  visible: boolean;
}

export const RequiredOrganizationModal = ({
  visible,
}: RequiredOrganizationModalProps) => {
  return (
    <Modal
      visible={visible}
      transparent={true}
      animationType="fade"
      statusBarTranslucent
      onRequestClose={() => {}}
    >
      <View className="flex-1 bg-black/50 justify-center items-center">
        <View className="flex-1 justify-center items-center">
          <OrganizationList hidePersonal={true} />
        </View>
      </View>
    </Modal>
  );
};
